module.exports = "<div class=component-calendar-taskbar> <div class=\"label-task approve-task\"> <div class=checkbox-label> <input type=checkbox class=checkbox_a /> <label id=select-children-{{this.field_id}} class=checkbox_a2> </label> </div> <label class=approve-label>审批</label> </div> <div class=\"label-task remind-task\"> <span class=\"checkbox-true checkbox_a3 icon-calendar icon-calendar-checkbox-true\"> </span> <div class=remind-label>提醒</div> </div> <div class=remind-group> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/calendar/left-content/leftContent.calendarSet/leftContent.calendarSet.html
// module id = 4890
// module chunks = 50